import { messageState } from '../initialState';
import { storeInsertItems, storeInsertItem, storeRemoveItem, storeUpdateObjectInArray } from '../utils/utils';
import { omit } from 'lodash';

export default function (state = messageState, action) {
  switch (action.type) {
    case 'FETCH_MESSAGES_REQUEST': {
      return {
        ...state,
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: true,
          loadingFetch: true,
          error: null,
        }),
      };
    }
    case 'FETCH_MESSAGES_SUCCESS': {
      return {
        ...state,
        messages: action.payload.results || action.payload,
        pagination: action.payload.results ? omit(action.payload, 'results') : state.pagination,
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: false,
          error: null,
        }),
      };
    }
    case 'FETCH_MESSAGES_FAIL': {
      return {
        ...state,
        messages: [],
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: false,
          error: action.payload,
        }),
      };
    }
    case 'FETCH_MESSAGE_DETAIL_SUCCESS': {
      // A freshly retrieved message replaces its copy in the list (e.g. is_read
      // flipped to true), or is added on top when it was not on this page —
      // that is how an email deep link surfaces a message from another page.
      const detail = action.payload;
      const exists = state.messages.some((m) => m.id === detail.id);
      return {
        ...state,
        messages: exists
          ? storeUpdateObjectInArray(state.messages, detail)
          : storeInsertItem(state.messages, detail),
        vehicleHistory: storeUpdateObjectInArray(state.vehicleHistory || [], detail),
      };
    }
    case 'FETCH_MESSAGE_DETAIL_REQUEST':
    case 'FETCH_MESSAGE_DETAIL_FAIL': {
      return state;
    }
    case 'FETCH_VEHICLE_MESSAGE_HISTORY_REQUEST': {
      return {
        ...state,
        vehicleHistoryStatus: Object.assign({}, state.vehicleHistoryStatus, {
          loading: true,
          error: null,
        }),
      };
    }
    case 'FETCH_VEHICLE_MESSAGE_HISTORY_SUCCESS': {
      return {
        ...state,
        vehicleHistory: Array.isArray(action.payload)
          ? action.payload
          : (action.payload.results || []),
        vehicleHistoryStatus: Object.assign({}, state.vehicleHistoryStatus, {
          loading: false,
          error: null,
        }),
      };
    }
    case 'FETCH_VEHICLE_MESSAGE_HISTORY_FAIL': {
      return {
        ...state,
        vehicleHistory: [],
        vehicleHistoryStatus: Object.assign({}, state.vehicleHistoryStatus, {
          loading: false,
          error: action.payload,
        }),
      };
    }
    case 'CREATE_MESSAGE_REQUEST': {
      return {
        ...state,
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: true,
          error: null,
        }),
      };
    }
    case 'CREATE_MESSAGE_SUCCESS': {
      const messages = Array.isArray(action.payload)
        ? storeInsertItems(state.messages, action.payload)
        : storeInsertItem(state.messages, action.payload);
      return {
        ...state,
        messages: messages,
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: false,
          error: null,
        }),
      };
    }
    case 'CREATE_MESSAGE_FAIL': {
      return {
        ...state,
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: false,
          error: action.payload,
        }),
      };
    }
    case 'CREATE_MESSAGE_RESPONSE_REQUEST': {
      return {
        ...state,
        messageResponseStatus: Object.assign({}, state.messageResponseStatus, {
          loading: true,
          error: null,
        }),
      };
    }

    case 'CREATE_MESSAGE_RESPONSE_SUCCESS': {
      const messageId = action.payload.message;
      const appendResponse = (list) => {
        const message = list.find(t => t.id == messageId);
        if (!message) return list;
        const newMessage = Object.assign({}, message, {
          responses: (message.responses || []).concat(action.payload),
        });
        return storeUpdateObjectInArray(list, newMessage);
      };
      return {
        ...state,
        messages: appendResponse(state.messages),
        vehicleHistory: appendResponse(state.vehicleHistory),
        messageResponseStatus: Object.assign({}, state.messageResponseStatus, {
          loading: false,
          error: null,
        }),
      };
    }

    case 'CREATE_MESSAGE_RESPONSE_FAIL': {
      return {
        ...state,
        messageResponseStatus: Object.assign({}, state.messageResponseStatus, {
          loading: false,
          error: action.payload,
        }),
      };
    }

    case 'UPDATE_MESSAGE_REQUEST': {
      return {
        ...state,
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: true,
          error: null,
        }),
      };
    }
    case 'UPDATE_MESSAGE_SUCCESS': {
      return {
        ...state,
        messages: storeUpdateObjectInArray(state.messages, action.payload),
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: false,
          error: null,
        }),
      };
    }
    case 'UPDATE_MESSAGE_FAIL': {
      return {
        ...state,
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: false,
          error: action.payload,
        }),
      };
    }
    case 'DELETE_MESSAGE_REQUEST': {
      return {
        ...state,
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: true,
          error: null,
        }),
      };
    }
    case 'DELETE_MESSAGE_SUCCESS': {
      return {
        ...state,
        messages: storeRemoveItem(state.messages, action.payload.id),
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: false,
          error: null,
        }),
      };
    }
    case 'DELETE_MESSAGE_FAIL': {
      return {
        ...state,
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: false,
          error: action.payload,
        }),
      };
    }
    case 'APPROVE_MESSAGE_REQUEST':
    case 'REJECT_MESSAGE_REQUEST': {
      return {
        ...state,
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: true,
          error: null,
        }),
      };
    }
    case 'APPROVE_MESSAGE_SUCCESS':
    case 'REJECT_MESSAGE_SUCCESS': {
      return {
        ...state,
        messages: storeUpdateObjectInArray(state.messages, action.payload),
        vehicleHistory: storeUpdateObjectInArray(state.vehicleHistory, action.payload),
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: false,
          error: null,
        }),
      };
    }
    case 'APPROVE_MESSAGE_FAIL':
    case 'REJECT_MESSAGE_FAIL': {
      return {
        ...state,
        messageStatus: Object.assign({}, state.messageStatus, {
          loading: false,
          error: action.payload,
        }),
      };
    }
    default:
      break;
  }
  return state;
}
